import { ApproveImportedInvoiceLinePayload, ApproveImportedInvoicePayload } from '@features/importedInvoices/query-api'
import { ImportedInvoiceReviewApprovableValues } from '@features/importedInvoices/types/importedInvoiceReviewApprovableValues'
import { getImportedInvoiceLineAmounts } from '@features/importedInvoices/utils/getImportedInvoiceLineAmounts'
import { getImportedInvoiceVatRate } from '@features/importedInvoices/utils/getImportedInvoiceVatRate'
import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { formatDateToString } from '../../../../../../../utils/formatDateToString'

/**
 * A blank description is left out. `exchangeRate` is never sent: the form has no field for it.
 * The VAT amount is calculated from the line's VAT rate, which approve requires, so this is `null`
 * when a line's rate is not one of `taxRates`.
 */
export const getApproveImportedInvoicePayload = (
  values: ImportedInvoiceReviewApprovableValues,
  taxRates: TaxRate[],
): ApproveImportedInvoicePayload | null => {
  const { client, currency, dueDate, issueDate, lines, referenceNumber } = values
  const invoiceLines: ApproveImportedInvoiceLinePayload[] = []

  for (const line of lines) {
    const { vatAmount } = getImportedInvoiceLineAmounts({
      amountExclVat: line.amountExclVat,
      currency,
      vatRate: getImportedInvoiceVatRate(taxRates, line.vatRateId),
    })

    if (vatAmount === null) {
      return null
    }

    const description = line.description.trim()

    invoiceLines.push({
      accountId: line.categoryId,
      ...(description ? { description } : {}),
      netAmount: line.amountExclVat,
      taxAmount: vatAmount,
      taxRateId: line.vatRateId,
    })
  }

  return {
    contactId: client.id,
    currencyId: currency,
    ...(dueDate ? { dueDate: formatDateToString(dueDate) } : {}),
    entryDate: formatDateToString(issueDate),
    invoiceLines,
    number: referenceNumber.trim(),
  }
}
